export default __webpack_public_path__ + "static/media/maxdome_more_info_small.av1.ab4a9d78.mp4";